import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { useSelector, useDispatch } from "react-redux";
import Step1 from "../../components/Quote/Step1";
import Step2 from "../../components/Quote/Step2";
import Step3 from "../../components/Quote/Step3";
import Step4 from "../../components/Quote/Step4";
import Step5 from "../../components/Quote/Step5";
import { getForm, getSteps } from "../../store/policy";
import { User, Users, FileCheck, PenTool, CreditCard } from "lucide-react";
import logo from "../../utils/img/loginLogo.png";

const stepIcons = [
  <User size={18} />,
  <Users size={18} />,
  <FileCheck size={18} />,
  <PenTool size={18} />,
  <CreditCard size={18} />,
];

const Index = ({ curr }) => {
  const dispatch = useDispatch();
  const [current, setCurrent] = useState(null);
  const { form, steps } = useSelector((state) => state.policySlice);

  useEffect(() => {
    if (
      sessionStorage.getItem("lastStep") &&
      parseInt(sessionStorage.getItem("lastStep")) > 3
    ) {
      setCurrent(parseInt(sessionStorage.getItem("lastStep")) - 3);
    } else {
      setCurrent(1);
    }
    if (!form) {
      dispatch(getForm());
    }
  }, []);

  useEffect(() => {
    const quotationForm = form?.find((f) => f?.sequence === 2);
    if (quotationForm?.id) {
      dispatch(getSteps(quotationForm.id));
    }
  }, [form]);

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <div className={styles.topBarInner}>
          <div className={styles.brandMark}>
            <img src={logo} alt="Eden Care" className={styles.brandLogo} />
          </div>
          <div className={styles.topBarRight}>
            <span className={styles.topBarBadge}>Policy Application</span>
          </div>
        </div>
      </div>

      <div className={styles.main}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h1 className={styles.headingMain}>
              {form?.find((f) => f?.sequence === 2)?.title}
            </h1>
            <p className={styles.subHeading}>
              Ucare Quote - Policy Application
            </p>
          </div>

          {current && (
            <div className={styles.stepper}>
              {steps &&
                steps.length > 0 &&
                steps.map((_, i) => {
                  const step = steps.find((s) => s?.step_number === i + 1);
                  const isActive = current - 1 === i;
                  const isCompleted = current - 1 > i;
                  return (
                    <React.Fragment key={i}>
                      <div
                        className={`${styles.stepItem} ${
                          isActive ? styles.stepActive : ""
                        } ${isCompleted ? styles.stepCompleted : ""}`}
                      >
                        <div className={styles.stepCircle}>
                          {isCompleted ? (
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                          ) : (
                            stepIcons[i] || <span>{i + 1}</span>
                          )}
                        </div>
                        <div className={styles.stepLabel}>
                          <span className={styles.stepNumber}>Step {i + 1}</span>
                          <span className={styles.stepTitle}>{step?.title}</span>
                        </div>
                      </div>
                      {i < steps.length - 1 && (
                        <div
                          className={`${styles.stepConnector} ${
                            isCompleted ? styles.stepConnectorDone : ""
                          }`}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          )}

          {current && (
            <div className={styles.stepContainer}>
              {current === 1 ? (
                <Step1 current={current} setCurrent={setCurrent} />
              ) : current === 2 ? (
                <Step2 current={current} setCurrent={setCurrent} />
              ) : current === 3 ? (
                <Step3 current={current} setCurrent={setCurrent} />
              ) : current === 4 ? (
                <Step4 current={current} setCurrent={setCurrent} />
              ) : (
                current === 5 && (
                  <Step5 current={current} setCurrent={setCurrent} />
                )
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Index;
